<template>
  <div class="life"
       id="lifetop">
    <Topper></Topper>
    <div class="nei_tit">
      <img src="../assets/life_tit.jpg"
           alt="">
      <span>品质生活</span>
    </div>
    <!-- 业务介绍 -->
    <div class="nei_jieshao">
      <h2>业务介绍</h2>
      <p>新绎生活是新奥集团下属品质生活产业板块，以“提高消费者生活品质”为使命，以家庭客户的品质生活需求为牵引，聚焦“居家”及“出行”两大核心生活场景，创新以健康为内核的品质生活产品与服务体系，打造“智能家”“智能游”生活产业智能与品质生活专业能力认知平台，联接、赋能品质生活产业生态，致力于成为新时代品质生活智能运营商，为客户打造健康品质生活。<br />
        目前，新绎在河北、广西、西藏、山东等地均有布局，2024年智能家生活服务客户超15.5万户，智能游生活游客接待量突破1234万人次，聚合生态超1000家。</p>
      <dl>
        <dt>智能家服务客户</dt>
        <dd>15.5<i>万户<sup>+</sup></i></dd>
      </dl>
      <dl>
        <dt>智能游接待游客</dt>
        <dd>1234万<i><sup>+</sup></i></dd>
      </dl>
      <dl>
        <dt>聚合生态</dt>
        <dd>1000<i><sup>+</sup></i></dd>
      </dl>
      <a href="http://www.ennovalife.com"
         class="viewmore">查看更多</a>
    </div>

    <!-- 健康家服务 -->
    <div class="jkjfw">
      <h2><i class="jkjfw_icon"></i>智能家服务</h2>
      <div class="life_info_sub">
        <li><i class="znjfwa"></i>聚焦家庭场景<br />打破服务时空边界</li>
        <li><i class="znjfwb"></i>智能链接用户<br />社区和生态资源</li>
        <li><i class="znjfwc"></i>居食动乐调养购<br />品质生活服务</li>
        <li><i class="znjfwd"></i>家庭智能健康<br />生活产品与服务体系</li>
      </div>
    </div>
    <div class="lkj">
      来康智能郡
    </div>
    <div class="life_wrapper">
      <p>
        来康智能郡是新绎倾力打造的智能社区品牌，经过30余年的沉淀与积累，将健康理念与智能能力融入社区环境、建筑、配套及运营服务中，打造以健康为内核的特色主题产品，甄选生态资源，搭建智能健康生活产品与服务体系。结合不同地域的优势、特色，已在全国打造都市、田园、滨海、艺术人文等不同主题的20余个来康智能郡项目，提供智能健康品质生活服务，让业主尊享健康美好生活。
      </p>
      <ul>
        <li><img src="../assets/tywqlkj.jpg"
               alt="">田园温泉•来康郡</li>
        <li><img src="../assets/bhdjlkj.jpg"
               alt="">滨海度假•来康郡</li>
        <li><img src="../assets/gefydlkj.jpg"
               alt="">高尔夫运动•来康郡</li>
        <li><img src="../assets/dsshlkj.jpg"
               alt="">都市生活•来康郡</li>
      </ul>
      <a href="https://ennovalife.com/znjsh"
         class="viewmore">查看更多</a>
    </div>

    <!-- <div class="lkw">
      来康网<a href="https://www.laikang.com/">
        <div class="arrow_btn animate__animated animate__fadeInLeft animate__infinite"></div>
      </a>
    </div>
    <div class="life_wrapper"
         style="padding-top:0.2rem">
      <p>
        来康网是聚焦 " 健康家 " 场景打造的健康专业能力认知平台 , 以三济抑熵理论为基础，认知健康专业能力，打造智能生活方式。<br />
        来康网基于智能物联实时获取健康数据，依托产业实践沉淀专家业务模型，持续训练生命健康大模型。以生命熵智能仿真为核心，统一健康能力语言，精准匹配需能力与供能力 , 以需供同智模式提升产业整体能力！
      </p>
    </div> -->

    <!-- 智能游服务 -->
    <div class="jkyfw">
      <h2><i class="jkyfw_icon"></i>智能游服务</h2>
      <div class="life_info_sub">
        <li><i class="znyfwa"></i>聚焦出游场景<br />打造智能旅行生活方式</li>
        <li><i class="znyfwb"></i>智能链接游客<br />商户、景区等旅游要素</li>
        <li><i class="znyfwc"></i>精准识别旅行需求<br />个性化行程规划、智能实时交互<br />等全游程服务</li>
        <li><i class="znyfwd"></i>提供多元生活方式<br />与旅游生态要素运营</li>
      </div>
    </div>
    <div class="kllyg">
      旅游智能港
    </div>
    <div class="life_wrapper">
      <p>
        旅游智能港是新绎依托山岳、海洋、人文等资源禀赋，打造以海岛度假、高原体验、人文艺术、山居生活等为特色的旅游目的地，项目落地广西、西藏、河北、山东等省。目前建设运营有梦廊坊、林芝、北海等多个旅游智能港。
      </p>
      <ul>
        <li><img src="../assets/mlflyzng.jpg"
               alt="">梦廊坊旅游智能港</li>
        <li><img src="../assets/lzlyzng.jpg"
               alt="">林芝旅游智能港</li>
        <li><img src="../assets/bhlyzng.jpg"
               alt="">北海旅游智能港</li>
      </ul>
      <a href="https://ennovalife.com/znysh"
         class="viewmore">查看更多</a>
    </div>
    <div class="enaowa">
      嗯噢哇
    </div>
    <div class="life_wrapper"
         style="padding-top:0.2rem">
      <p>
        嗯噢哇是新绎生活旗下专注于旅游场景的专业能力认知平台，以“能力化”视角重构旅游产业价值链，平台以构建“需供同智” 的全新产业模式为核心，为游客提供精准匹配的个性化体验，为商家及目的地运营者搭建智能获客、随需服务、高效运营的全链路体系，重新定义“所想即所得”的智能旅行生活新范式。
        <br />
        <!-- <img src="../assets/eow_qr.jpg"
             alt=""
             style="width:3.2rem;height:3.2rem; margin-left:2.5rem; margin-top:.2rem;"> -->
      </p>
      <a href="https://www.enowa.cn/"
         class="viewmore">查看更多</a>
    </div>

    <!-- 健康服务 -->
    <!-- Swiper -->
    <div class="swiper-containera">
      <div class="jkfw_info">
        <h2><i class="jkfw_icon"></i>健康服务</h2>
        <p>新绎在大健康领域深耕多年，基于生命健康理论与三济抑熵疗愈体系持续打造养、康、医、护、险产业集群，将居家健康服务、智能科技服务应用于健康生活、慢病管理、疾病诊疗、长者颐养、健康保险等实体业务，以智能能力赋能产业升级，落地最佳实践，助力人民生活品质不断提升。
          <a href="https://ennovalife.com/jkfw"
             class="viewmoreb">查看更多</a>
        </p>
        <div class="lifehealth_sub">
          <ul>
            <li><a href="http://ennovalife.com/jksh"
                 target="_blank"
                 class="mytrans radius50">七修生活</a></li>
            <li><a href="http://ennovalife.com/mbgl"
                 target="_blank"
                 class="mytrans radius50">慢病管理</a></li>
            <li><a href="http://ennovalife.com/zzyy"
                 target="_blank"
                 class="mytrans radius50">长者颐养</a></li>
            <li><a href="http://ennovalife.com/jkbx"
                 target="_blank"
                 class="mytrans radius50">健康保险</a></li>
          </ul>
        </div>
      </div>

    </div>
    <!-- Swiper -->

    <div class="lkw">
      来康科技<a href="http://ennovalife.com/eow_03280956_225">
        <div class="arrow_btn animate__animated animate__fadeInLeft animate__infinite"></div>
      </a>
    </div>
    <div class="life_wrapper"
         style="padding-top:0.2rem">
      <p>
        来康科技秉持“让天下人少生病”的使命，基于三济抑熵理论基础，致力于打造健康专业智能、驱动健康生活方式、升级健康产业协同模式。<br />
        围绕家庭健康需求，将健康智伴产品融入家庭生活，从身心灵全面认知家庭用户健康状态，提供一站式、个性化的健康服务，呵护家人健康。<br />
        依托生命熵智能仿真，打造健康专业智能模型，统一健康能力语言，实现需供顺畅沟通，以需供同智模式驱动健康产业能力智能化升级。
      </p>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Swiper from "swiper";
import Topper from "./Topper";
import Footer from './Footer.vue';
export default {
  components: {
    Topper,
    Footer
  },
  name: "life",
  data () {
    return {
    };
  },

  mounted () {

    new Swiper(".swiper-containera", {
      loop: true,
      // 如果需要分页器
      //   grabCursor: true,
      //   centeredSlides: true,
      //   slidesPerView: "auto",
      autoplay: false,
      allowTouchMove: true,
      autoplayDisableOnInteraction: false,//用户操作后是否自动播放
      //   parallax: true,//允许延迟
      pagination: '.swiper-pagination',
      paginationClickable: true,
      paginationBulletRender: function (swiper, index, className) {
        var Territory = document.querySelectorAll('.Territory')[index + 1].getAttribute('data-Territory');
        return '<div class="' + className + '">' + Territory + '</div>';
      }
    });

    let maodian = this.$route.params.maodian;
    console.log(maodian);
    if (maodian) {
      const targetElement = document.querySelector(maodian);
      window.scrollTo({ top: targetElement.offsetTop, behavior: 'smooth' });
    } else {
      window.scrollTo(0, 0);
    }
  },
  methods: {
    // goToUrl () {
    //   window.location.href = "https://www.laikangyundong.com";
    // }
  }
};
</script>

<style scoped>
.life {
  background: #fff;
  width: 750px;
  height: auto;
  overflow: hidden;
}
.nei_tit {
  width: 750px;
  height: 450px;
  position: relative;
  margin-top: 95px;
}
.nei_tit img {
  width: 750px;
  height: 450px;
  position: absolute;
  left: 0;
  top: 0;
}
.nei_tit span {
  position: absolute;
  left: 40px;
  top: 200px;
  font-size: 48px;
  color: #fff;
  font-weight: 500;
}
h2 {
  font-size: 36px;
  color: #1d2129;
  display: block;
  padding: 60px 40px 30px 40px;
  width: 670px;
  text-align: left;
  float: left;
}
p {
  font-size: 28px;
  color: #323233;
  width: 670px;
  text-align: left;
  padding: 10px 40px;
  float: left;
  line-height: 150%;
}
.nei_jieshao {
  width: 750px;
  height: 900px;
  background: url(../assets/introduce_bg.jpg) center no-repeat;
  background-size: 100% 100%;
  float: left;
}
.nei_jieshao dl {
  margin-top: 30px;
  width: 200px;
  margin-right: 20px;
  float: left;
  padding-left: 30px;
}
.nei_jieshao dl dt {
  font-size: 28px;
  color: #323233;
  text-align: left;
}
.nei_jieshao dl dd {
  font-size: 44px;
  color: #013b78;
  text-align: left;
  margin-top: 10px;
}
.nei_jieshao dl dd i {
  font-size: 30px;
  font-weight: 600;
  font-style: normal;
}

.jkjfw {
  width: 750px;
  height: 600px;
  float: left;
  background: url(../assets/health_bg.jpg);
  background-size: 100% 100%;
}
.life_info_sub {
  width: 700px;
  padding: 25px;
  float: left;
}
.life_info_sub li {
  width: 349px;
  height: 160px;
  float: left;
  text-align: center;
  font-size: 24px;
  color: #fff;
}
.life_info_sub li i {
  display: block;
  width: 60px;
  height: 60px;
  margin: 10px auto;
}
.life_info_sub li i.znjfwa {
  background: url(http://www.lffeiyasi.com/images/icons.png) 0 -540px;
  background-size: 1200px 1200px;
}
.life_info_sub li i.znjfwb {
  background: url(http://www.lffeiyasi.com/images/icons.png) -60px -540px;
  background-size: 1200px 1200px;
}
.life_info_sub li i.znjfwc {
  background: url(http://www.lffeiyasi.com/images/icons.png) -120px -540px;
  background-size: 1200px 1200px;
}
.life_info_sub li i.znjfwd {
  background: url(http://www.lffeiyasi.com/images/icons.png) -180px -540px;
  background-size: 1200px 1200px;
}
.life_info_sub li i.znyfwa {
  background: url(http://www.lffeiyasi.com/images/icons.png) -240px -540px;
  background-size: 1200px 1200px;
}
.life_info_sub li i.znyfwb {
  background: url(http://www.lffeiyasi.com/images/icons.png) -300px -540px;
  background-size: 1200px 1200px;
}
.life_info_sub li i.znyfwc {
  background: url(http://www.lffeiyasi.com/images/icons.png) -360px -540px;
  background-size: 1200px 1200px;
}
.life_info_sub li i.znyfwd {
  background: url(http://www.lffeiyasi.com/images/icons.png) -420px -540px;
  background-size: 1200px 1200px;
}
.jkjfw .jkjfw_icon {
  width: 80px;
  height: 80px;
  background: url(../assets/jkjfw_icon.png);
  background-size: 100% 100%;
  float: left;
  margin-right: 30px;
}
.jkjfw h2 {
  color: #fff;
  line-height: 80px;
  padding-bottom: 10px;
}
.jkjfw p {
  color: #fff;
}
.lkj {
  width: 670px;
  height: 200px;
  float: left;
  background: url(../assets/lkj.jpg);
  background-size: 100% 100%;
  font-size: 36px;
  color: #fff;
  padding: 40px;
  text-align: left;
  font-weight: 600;
  line-height: 200px;
}
.life_wrapper {
  width: 750px;
  height: auto;
  float: left;
  padding: 50px 0px;
}
.life_wrapper ul {
  width: 690px;
  padding: 20px 30px;
  float: left;
}
.life_wrapper ul li {
  width: 230px;
  text-align: center;
  font-size: 26px;
  float: left;
}
.life_wrapper ul li img {
  width: 210px;
  height: 150px;
}
.viewmore {
  width: 50%;
  display: block;
  height: 55px;
  border: 1px solid #ddd;
  text-align: center;
  font-size: 0.35rem;
  line-height: 55px;
  float: left;
  margin-left: 25%;
  margin-top: 50px;
  background: #fff;
  color: #666;
}
.viewmoreb {
  width: 50%;
  display: block;
  height: 55px;
  border: 1px solid #fff;
  text-align: center;
  font-size: 0.35rem;
  line-height: 55px;
  float: left;
  margin-left: 25%;
  margin-top: 50px;
  color: #fff;
}
.lkw {
  width: 670px;
  height: 250px;
  float: left;
  background: url(../assets/lkw.jpg);
  background-size: 100% 100%;
  font-size: 36px;
  color: #fff;
  padding: 40px;
  text-align: left;
  font-weight: 600;
  line-height: 200px;
  position: relative;
  margin-top: 20px;
}
.arrow_btn {
  width: 100px;
  height: 60px;
  float: left;
  background: url(../assets/arrow_white.png) left center no-repeat;
  background-size: 34px 27px;
  position: absolute;
  left: 650px;
  top: 110px;
}
.jkyfw {
  width: 750px;
  height: 600px;
  float: left;
  background: url(../assets/travle_bg.jpg);
  background-size: 100% 100%;
}
.jkyfw .jkyfw_icon {
  width: 80px;
  height: 80px;
  background: url(../assets/jkyfw_icon.png);
  background-size: 100% 100%;
  float: left;
  margin-right: 30px;
}
.jkyfw h2 {
  color: #fff;
  line-height: 80px;
  padding-bottom: 10px;
}
.jkyfw p {
  color: #fff;
}
.kllyg {
  width: 670px;
  height: 200px;
  float: left;
  background: url(../assets/klly.jpg);
  background-size: 100% 100%;
  font-size: 36px;
  color: #fff;
  padding: 40px;
  text-align: left;
  font-weight: 600;
  line-height: 200px;
  position: relative;
}
.enaowa {
  width: 670px;
  height: 250px;
  float: left;
  background: url(../assets/enaowaa.jpg);
  background-size: 100% 100%;
  font-size: 36px;
  color: #fff;
  padding: 40px;
  text-align: left;
  font-weight: 600;
  line-height: 200px;
  position: relative;
}

.swiper-containera {
  width: 750px;
  height: 800px;
  float: left;
  position: relative;
  background: url(../assets/jksh.jpg);
  background-size: 100% 100%;
}
.lifehealth_sub {
  width: 700px;
  height: auto;
  overflow: hidden;
  padding: 25px;
  position: absolute;
  left: 0;
  top: 550px;
}
.lifehealth_sub li {
  width: 155px;
  height: 155px;
  float: left;
  padding: 10px;
}
.lifehealth_sub li a {
  display: block;
  width: 155px;
  height: 155px;
  background: #fff;
  text-align: center;
  font-size: 26px;
  line-height: 28px;
  font-weight: bold;
  color: #013b78;
  border-radius: 50%;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;
}
.swiper-containera .swiper-wrapper {
  width: 750px;
  height: 1038px;
  position: relative;
}
.jkfw_info {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 100;
}
.jkfw_info h2 {
  color: #fff;
  line-height: 80px;
  position: absolute;
  left: 10px;
  top: 0px;
  z-index: 20;
}
.jkfw_info h2 i.jkfw_icon {
  width: 80px;
  height: 80px;
  background: url(../assets/jkfw_icon.png);
  background-size: 100% 100%;
  float: left;
  margin-right: 30px;
}
.jkfw_info p {
  color: #fff;
  position: absolute;
  left: 10px;
  top: 160px;
  z-index: 20;
  padding-right: 20px;
}
.swiper-containera .swiper-slide {
  width: 750px;
  height: 1038px;
  position: relative;
}
.swiper-containera .swiper-slide h2 {
  color: #fff;
  line-height: 80px;
  position: absolute;
  left: 10px;
  top: 0px;
  z-index: 20;
}
.swiper-containera .swiper-slide h2 i.jkfw_icon {
  width: 80px;
  height: 80px;
  background: url(../assets/jkfw_icon.png);
  background-size: 100% 100%;
  float: left;
  margin-right: 30px;
}
.swiper-containera .swiper-slide p {
  color: #fff;
  position: absolute;
  left: 10px;
  top: 160px;
  z-index: 20;
  padding-right: 20px;
}
.swiper-containera .swiper-slide img {
  width: 750px;
  height: 1038px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
}
</style>
<style>
.swiper-containera .swiper-pagination-bullet {
  width: 20%;
  float: left;
  height: 100px;
  margin: 0;
  border-top: 1px solid #fff;
  background: none;
  border-radius: 0;
  font-size: 28px;
  color: #fff;
  line-height: 100px;
  opacity: 0.7;
}
.swiper-containera .swiper-pagination-bullet-active {
  background: #fff;
  color: #013b78;
  border-top: 5px solid #6eba2c;
  opacity: 1;
}
.swiper-container-horizontal
  > .swiper-pagination-bullets
  .swiper-pagination-bullet {
  margin: 0;
}
.swiper-container-horizontal > .swiper-pagination-bullets,
.swiper-pagination-custom,
.swiper-pagination-fraction {
  bottom: 300px;
}
</style>
